import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { AuthService } from '../auth.service';
import { AppCommonService } from '../appcommon.service';
import { BlogService } from '../blogs/blog.service';
import { IBlog, BlogDetails, IDriverClubNews, DriversClubNewsDetails } from '../blogs/blog';
import { ActivatedRoute } from '@angular/router';
declare var $: any;
@Component({
  templateUrl: "./driversclubnewsdetail.component.html"
})
export class DriversClubNewsDetailComponent implements OnInit, AfterViewInit, OnDestroy {
  public pageTitle: string = 'Drivers Club News Detail';
  p: number = 1;
  newsList: IDriverClubNews[];
  inews: IDriverClubNews[];
  news: DriversClubNewsDetails = new DriversClubNewsDetails();
  slug: string;
  private sub: any;
  dtitle: string = "More Drivers Club Offers";
  constructor(private authService: AuthService,
    public blogService: BlogService,
    private route: ActivatedRoute,
    private appCommonService: AppCommonService) {
    this.appCommonService.pageContentAdditionalClass = "home-page main-page";
    this.appCommonService.pageName = this.pageTitle;
  }
  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      this.slug = params['slug'];
      this.loadNewssList();
      window.scrollTo(0, 0);
    });
  }

  ngAfterViewInit() {

  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  loadNewssList() {
    this.blogService.getDriversClubNewsList()
      .subscribe(
      (newsitems: IDriverClubNews[]) => {
        this.inews = newsitems.filter(b => b.slug == this.slug);
        newsitems = newsitems.filter(b => b.slug != this.slug);
        this.newsList = newsitems;
      },
      (error: any) => {
        this.blogService.showError("Drivers club news retrieval problem", <any>error)
      }
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/genericpages/driversclubnewsdetail.componen.ts